import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type {
  AdminLeadListQuery,
  AdminLeadListResponse,
  AdminLeadResponse,
  AdminLeadStatsResponse,
  PatchAdminLeadRequest,
} from './admin-lead-api.interface';
import type { PublicLeadApiConfig } from './public-lead-api.interface';

@Injectable({ providedIn: 'root' })
export class AdminLeadApiService {
  readonly #http = inject(HttpClient);
  private apiUrl = '';

  public configure(config: PublicLeadApiConfig): void {
    this.apiUrl = config.apiUrl;
  }

  public getStats(): Observable<AdminLeadStatsResponse> {
    return this.#http.get<AdminLeadStatsResponse>(
      `${this.apiUrl}/admin/leads/stats`,
    );
  }

  public listLeads(
    query: AdminLeadListQuery = {},
  ): Observable<AdminLeadListResponse> {
    const params: Record<string, string | number> = {};
    if (query.section) {
      params['section'] = query.section;
    }
    if (query.kind) {
      params['kind'] = query.kind;
    }
    if (query.status) {
      params['status'] = query.status;
    }
    if (query.search?.trim()) {
      params['search'] = query.search.trim();
    }
    if (query.cursor) {
      params['cursor'] = query.cursor;
    }
    if (query.limit != null) {
      params['limit'] = query.limit;
    }

    return this.#http.get<AdminLeadListResponse>(`${this.apiUrl}/admin/leads`, {
      params,
    });
  }

  public getLead(id: string): Observable<AdminLeadResponse> {
    return this.#http.get<AdminLeadResponse>(
      `${this.apiUrl}/admin/leads/${id}`,
    );
  }

  public patchLead(
    id: string,
    body: PatchAdminLeadRequest,
  ): Observable<AdminLeadResponse> {
    return this.#http.patch<AdminLeadResponse>(
      `${this.apiUrl}/admin/leads/${id}`,
      body,
    );
  }
}
